import { render, staticRenderFns } from "./IconRewardEmptyList.vue?vue&type=template&id=4179f166"
import script from "./IconRewardEmptyList.vue?vue&type=script&lang=js"
export * from "./IconRewardEmptyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports